import { Factory } from 'miragejs';
import { faker } from '@faker-js/faker';

faker.seed(1);

export default Factory.extend({
	id: () => faker.string.uuid(),
	docGedId: () => faker.number.int({ min: 100, max: 999 }).toString(),
	documentTypeId: () => faker.number.int({ min: 100, max: 999 }).toString(),
	documentTypeDesc: () => faker.lorem.words(200),
	version: () => faker.number.int({ min: 1, max: 10 }),
	additionalInfo: () => faker.lorem.words(10),
	date: () => faker.date.past(0.3, '2022-00-00'),
	format: () => 'pdf',
});
